export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    mine: {
      key: 'mine',
      name: 'entity.asteroidBelt.occupation.mine',
    },
    drones: {
      key: 'drones',
      name: 'entity.asteroidBelt.occupation.drones',
    },
    base: {
      key: 'base',
      name: 'entity.asteroidBelt.occupation.base',
    },
    pirates: {
      key: 'pirates',
      name: 'entity.asteroidBelt.occupation.pirates',
    },
    patrol: {
      key: 'patrol',
      name: 'entity.asteroidBelt.occupation.patrol',
    },
  },
};
